import { createContext as t } from "react";
const o = {
  modalContent: null,
  setModalContent: () => {
  }
}, n = t(o);
export {
  n as ModalContext
};
